// naturalKeyImpl :: forall r. (Int -> r) -> (String -> r) -> String -> Array r
export function naturalKeyImpl(Num) {
  return function (Str) {
    return function (s) {
      const result = [];
      for (let i = 0; i < s.length; ) {
        const start = i;
        const currentChunkIsDigit = isDigit(s.charAt(i));
        do {
          i++;
        } while (i < s.length && isDigit(s.charAt(i)) === currentChunkIsDigit);
        const chunk = s.substring(start, i);
        result.push(currentChunkIsDigit ? Num(parseInt(chunk)) : Str(chunk));
      }
      return result;
    };
  };
}

function isDigit(c) {
  return c >= "0" && c <= "9";
}
